<template>
	<v-container>
			<div class="base-page">
				<logo-with-title :title = "$t('forgotPasswordPage.resetPassword')"/>
				<v-form
							ref="form"
							method="POST"
							action="/reset-password"
						>
							<input
								type="hidden"
								name="_token"
								:value="csrf"
							>
							<input
								type="hidden"
								name="token"
								:value="token"
							>
															<label for="email">
				<span class="font-weight-medium base-label pa-2">{{ $t('email') }}</span>
				<span class="text--red red--text">*</span>
			</label>
			<v-text-field v-model="form.email"
										class="mt-1 base-input-1 base-rounded" outlined required
										type="email" :rules="[rules.required, rules.email]"
										name="email"
										:placeholder="$t('enterEmail')"
										:error-messages="errors.email"
			/>
			<label for="password">
				<span class="font-weight-medium base-label">{{ $t('password') }}</span>
				<span class="text--red red--text">*</span>
			</label>
			<v-text-field id="password" v-model="form.password"
										class="mt-1 base-input-1 base-rounded" outlined required
										type="password" :rules="[rules.required]"
										name="password"
										:placeholder="$t('enterPassword')"
										:error-messages="errors.password"
			/>

			<label class="" for="confirmationPassword">
				<span class="font-weight-medium base-label">{{ $t('confirmPassword') }}</span>
				<span class="text--red red--text">*</span>
			</label>
			<v-text-field id="confirmationPassword" v-model="form.password_confirmation"
										class="mt-1 base-input-1 base-rounded"
										outlined required type="password" :rules="[rules.required, rules.password]"
										name="password_confirmation"
										:placeholder="$t('enterPassword')"
										:error-messages="errors.password_confirmation"
			/>

							<v-row justify="center">
								<v-col>
									<v-alert
										v-if="showErrors"
										dense
										outlined
										type="error"
									>
										<p
											v-for="(error,index) in errorBag"
											:key="error+index"
										>
											{{ error.toString() }}
										</p>
									</v-alert>
								</v-col>
							</v-row>
							<v-card-actions class="d-flex flex-column mt-8">
								<v-row>
									<v-col>
										<v-btn
											type="submit" block color="btnColor" rounded>
											{{$t('forgotPasswordPage.resetPassword')}}
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-form>
				<lang-select />
			</div>
	</v-container>
</template>

<script>
import LangSelect from "../../components/LangSelect.vue";
import LogoWithTitle from "@/components/LogoWithTitle";
import rules from "../../helpers/rules";

export default {
	name: "ResetPassword",
	components: { LogoWithTitle, LangSelect },
	props: {
		admin: {
			type: Boolean,
		},
	},
	data: () => ({
		showError: false,
		disabled: false,
		form: {
			email: "",
			password: "",
			password_confirmation: "",
		},
		errors: {},
		rules
	}),
	computed: {
		csrf () {
			return document.querySelector("meta[name=csrf-token]").getAttribute("content");
		},
		token () {
			return this.$route.params.token;
		},
		errorBag () {
			return window.errorsBag;
		},
		showErrors () {
			return (Object.values(this.errorBag).length > 0 || (this.errorBag && this.errorBag.length > 0));
		},
	},
	created () {
		this.form.email = this.$route.query.email;
	},
};
</script>

<style lang="scss" scoped>
</style>
